module.exports = __webpack_public_path__ + "img/character-3.f4b3c929.png";